import React, { useCallback } from 'react';
import { Paper } from '@mui/material';
import { hydrateArtifactByRef } from '../../copilot/hooks/useArtifactHydration';
import { ChatStoreProvider, type ApprovalAction } from '../../../chat/core';
import { ChatPanelV2 } from '../../../chat/panel';
import { useL2CChatStore } from '../stores/useL2CChatStore';
import { l2cChat } from '../l2cChat';

interface LeadToCashChatPanelProps {
  width: number;
  onSend: (message: string) => void;
  onStop: () => void;
  onSQLApproval: (action: ApprovalAction, editedSql?: string, reason?: string) => void;
}

/**
 * The chat docked beside the Lead-to-Cash monitor.
 */
export default function LeadToCashChatPanel({
  width,
  onSend,
  onStop,
  onSQLApproval,
}: LeadToCashChatPanelProps) {
  const title = useL2CChatStore((s) => s.threadTitle) ?? 'Lead-to-Cash';

  const handleArtifactHydrate = useCallback((artifactId: string) => {
    void hydrateArtifactByRef(artifactId, useL2CChatStore.getState());
  }, []);

  return (
    <Paper
      variant="outlined"
      sx={(t) => ({
        width,
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        borderRadius: `${t.ds?.radius?.md ?? 8}px`,
        overflow: 'hidden',
      })}
    >
      <ChatStoreProvider store={useL2CChatStore}>
        <ChatPanelV2
          place={l2cChat}
          title={title}
          subtitle="Chain analysis assistant"
          onSend={onSend}
          onStop={onStop}
          onSQLApproval={onSQLApproval}
          onArtifactHydrate={handleArtifactHydrate}
        />
      </ChatStoreProvider>
    </Paper>
  );
}
